import React from 'react';

function BitcoinLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#F7931A" />
      <text x="32" y="40" textAnchor="middle" fontSize="32" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">
        {'\u20BF'}
      </text>
    </svg>
  );
}

function EthereumLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <defs>
        <linearGradient id="eth-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#8A92B2" />
          <stop offset="100%" stopColor="#627EEA" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="32" fill="#F3F5FF" />
      <path d="M32 8 19 32l13-7 13 7Z" fill="url(#eth-grad)" />
      <path d="M32 56 19 35l13 8 13-8Z" fill="#627EEA" />
      <path d="M32 25 19 32l13 8 13-8Z" fill="#A9B7FF" />
    </svg>
  );
}

function TetherLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#26A17B" />
      <path d="M16 18h32v6H35v6.4c8.6.4 15 2.2 15 4.4 0 2.5-8 4.5-18 4.5S14 37.3 14 34.8c0-2.2 6.4-4 15-4.4V24H16z" fill="#fff" />
      <ellipse cx="32" cy="34.8" rx="13.5" ry="2.8" fill="none" stroke="#fff" strokeWidth="2.5" />
      <rect x="29.5" y="24" width="5" height="20" rx="2.5" fill="#fff" />
    </svg>
  );
}

function UsdcLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#2775CA" />
      <path d="M20 20a18 18 0 0 0 0 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
      <path d="M44 20a18 18 0 0 1 0 24" fill="none" stroke="#fff" strokeWidth="3.5" strokeLinecap="round" />
      <text x="32" y="39" textAnchor="middle" fontSize="24" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">
        $
      </text>
    </svg>
  );
}

function TronLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#EF0027" />
      <path d="M16 16 47 23 33 48 16 16Zm10 7 13 3-7 12-6-15Zm14 4 4 2-7 10 3-12Z" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinejoin="round" />
    </svg>
  );
}

function BnbLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#F0B90B" />
      <path d="m32 15 6 6-6 6-6-6 6-6Zm-10 10 6 6-6 6-6-6 6-6Zm20 0 6 6-6 6-6-6 6-6Zm-10 10 6 6-6 6-6-6 6-6Z" fill="#fff" />
    </svg>
  );
}

function SolanaLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <defs>
        <linearGradient id="sol-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#14F195" />
          <stop offset="100%" stopColor="#9945FF" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="32" fill="#0C0C0F" />
      <path d="M18 20c0-1.7 1.3-3 3-3h24c2.7 0 4 3.4 2 5.3l-4.5 4.2a4 4 0 0 1-2.7 1H16.8c-2.7 0-4-3.4-2-5.3Z" fill="url(#sol-grad)" />
      <path d="M18 31c0-1.7 1.3-3 3-3h24c2.7 0 4 3.4 2 5.3l-4.5 4.2a4 4 0 0 1-2.7 1H16.8c-2.7 0-4-3.4-2-5.3Z" fill="url(#sol-grad)" opacity="0.85" />
      <path d="M18 42c0-1.7 1.3-3 3-3h24c2.7 0 4 3.4 2 5.3l-4.5 4.2a4 4 0 0 1-2.7 1H16.8c-2.7 0-4-3.4-2-5.3Z" fill="url(#sol-grad)" opacity="0.7" />
    </svg>
  );
}

function LitecoinLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#345D9D" />
      <text x="32" y="40" textAnchor="middle" fontSize="28" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">
        {'\u0141'}
      </text>
    </svg>
  );
}

function TonLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#0098EA" />
      <path d="M20 18h24c2.2 0 3.8 2.1 3.1 4.2L35.3 47.1a3.5 3.5 0 0 1-6.6 0L16.9 22.2C16.2 20.1 17.8 18 20 18Z" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinejoin="round" />
      <path d="M24 22h16L32 39Z" fill="#fff" />
    </svg>
  );
}

function BaseLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#0052FF" />
      <circle cx="32" cy="32" r="14" fill="none" stroke="#fff" strokeWidth="8" />
      <circle cx="46" cy="32" r="4" fill="#fff" />
    </svg>
  );
}

function SuiLogo() {
  return (
    <svg viewBox="0 0 64 64" width="100%" height="100%" aria-hidden="true">
      <circle cx="32" cy="32" r="32" fill="#6FBCF0" />
      <path d="M32 13c8 10 12 16 12 23 0 8-5.4 14-12 14s-12-6-12-14c0-7 4-13 12-23Z" fill="none" stroke="#fff" strokeWidth="3.2" />
      <path d="M27 35c1.4 2.8 3.1 4.2 5 4.2s3.6-1.4 5-4.2" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" />
    </svg>
  );
}

const LOGO_MAP = {
  btc: BitcoinLogo,
  eth: EthereumLogo,
  usdt: TetherLogo,
  usdc: UsdcLogo,
  trx: TronLogo,
  bnb: BnbLogo,
  sol: SolanaLogo,
  ltc: LitecoinLogo,
  ton: TonLogo,
  baseeth: BaseLogo,
  sui: SuiLogo,
};

export default function CryptoLogo({ cryptoId, size = 40 }) {
  const LogoComponent = LOGO_MAP[String(cryptoId || '').toLowerCase()] || BitcoinLogo;
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
      aria-hidden="true"
    >
      <LogoComponent />
    </div>
  );
}
